<template>
  <!-- {{selectedItem}} -->
  <!-- {{ items }} -->
  <!-- {{propsitems}} -->
  <!--{{ requestForm }} -->
  <b-form @submit.prevent="SingleEntrySubmit">
    <b-row>
      <b-col lg="2" md="2" sm="3" cols="12">
        <div class="d-flex gap-2 mt-3 singleentryposition">
          <InputSwitch v-model="SingleEntry.singleentry" @click="InputSwitch" class="singleswitch" />
          <label>{{
            SingleEntry.singleentry ? "Single Entry" : "Bulk Entry"
          }}</label>
        </div>
      </b-col>
      <template v-if="SingleEntry.singleentry">
        <b-col lg="3" md="3" sm="6" cols="12" class="my-3">
          <label>{{ $t("grn.itemname") }}<span class="red"> *</span></label>
          <AutoComplete :name="$t('grn.itemname')" :label="$t('grn.itemname')" :id="$t('grn.itemname')"
            v-model="SingleEntry.item" :required-icon="true" :rules="{ required: true }" :items="itemsList"
            @item-select="selectItem" @keyup="LoadItem" />
        </b-col>
        <b-col lg="2" md="2" sm="3" cols="12" class="my-3">
          <TextField :id="$t('grn.qty')" :name="$t('grn.qty')" :label="$t('grn.qty')" :rules="{ required: false }"
            v-model="SingleEntry.qty" type="number" placeholder=" " required: true :required-icon="true"
            @keyup="ItemQuantityCheck()" />
        </b-col>
        <b-col lg=" 2" md="2" sm="3" cols="12" class="my-3" v-if="RequiredField.BatchRequired">
          <TextField :id="$t('grn.batch')" :name="$t('grn.batch')" :label="$t('grn.batch')" :rules="{ required: false }"
            v-model="SingleEntry.batch" type="text" required: true :required-icon="true" placeholder=" " />
        </b-col>
        <b-col lg="2" md="2" sm="4" cols="12" class="my-3" v-if="RequiredField.ExpiryDtRequired">
          <Datepicker :label="$t('grn.expdate')" dateformat="dd-mm-yy" v-model="SingleEntry.expirydate" required: true
            :required-icon="true" />
        </b-col>
        <!-- <b-col lg=" 2" md="2" sm="3" cols="12" class="my-3">
          <TextField :id="$t('grn.supplierbarcode')" :name="$t('grn.supplierbarcode')"
            :label="$t('grn.supplierbarcode')" :rules="{ required: false }" v-model="SingleEntry.SupplierBarCode"
            type="text" required: false :required-icon="false" placeholder=" " />
        </b-col> -->
        <b-col lg="1" md="1" sm="3" cols="12" class="my-3">
          <Footer :label="$t('grn.add')" :cancelhide="false" class="mt-4" />
        </b-col>
      </template>
    </b-row>
  </b-form>

  <!-- <NormalTable v-model:value="items" :paginator="true" class="p-datatable-gridlines" :rows="10" dataKey="Id"
    :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="headers"
    :globalFilterFields="globalFilterFields" :filters="filters" :selectionMode="true" :exceldownload="true"
    v-model:selection="selectedItem" @update:selection="$.emit('selectedItem', selectedItem)"
    :addnewbtn="SingleEntry.singleentry ? false : true" @updatedata="Itemschanges"
    :normaltablesearch="SingleEntry.singleentry ? false : true"> -->

  <Tableview :value="items" :paginator="true" class="p-datatable-gridlines" :rows="10" :rowHover="true"
    filterDisplay="menu" responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields"
    :filters="filters" :dataKey="item => `${item.ItemId}_${item.Brand}_${item.ModelNumber}_${item.Size}`"
    :serialNumber="true" :selectionMode="true" @selection="SelectItems" :selection="selectedItem"
    :addnewbtn="SingleEntry.singleentry ? false : true" :searchbox="SingleEntry.singleentry ? false : true">

    <template v-slot:Addcustom>
      <span>
        <AddButton btnname="Add Items" @click="$.emit('AddSelectItems', selectedItem)" class="me-3"></AddButton>
      </span>
    </template>

    <template v-slot:BarCode="{ data }">
      <span>
        {{ data.BarCode }}
      </span>
    </template>

    <template v-slot:Brandmodelsize="{ data }">
      <span>
        <template v-if="data.BrandName">{{ data.BrandName }}</template>
        <template v-if="data.BrandName && data.ModelNumberName">/</template>
        <template v-if="data.ModelNumberName">{{
          data.ModelNumberName
        }}</template>
        <template v-if="(data.BrandName || data.ModelNumberName) && data.SizeName">/</template>
        <template v-if="data.SizeName">{{ data.SizeName }}</template>
      </span>
    </template>
    <template v-slot:dropdownfilter v-if="SingleEntry.singleentry ? false : true">
      <ExportImport @ExcelDataImport="ExcelDataImport"></ExportImport>

      <span class="field mx-3">
        <CustomDropdown name="itemcatfilter" v-model="itemcatfilter" :items="itemcatfilteroptions"
          placeholder="Filter Items" @update:modelValue="filterCondition" />
      </span>
    </template>
    <template v-slot:Qty="{ data }">
      <div class="label-d-none tablefield mb-0">
        <InputText
          :name="`'Qty'${data.ItemId}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.ItemQuantity}`"
          :id="`'Qty'${data.ItemId}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.ItemQuantity}`"
          label="" v-model="data.ItemQuantity" :rules="{ numeric: true }" :disabled="data.IsConsigneeItem == 1 || data.DCType == 1 ? true : false
            " @keyup="AllItemQtyOnChange(data)" />
      </div>
    </template>
    <template v-slot:BatchNo="{ data }">
      <div class="label-d-none tablefield mb-0">
        <InputText v-if="data.BatchRequired" type="text" placeholder="" clearable autocomplete="off"
          :title="data.BatchNo"
          :name="`'BatchNo'${data.ItemId}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
          :id="`'BatchNo'${data.ItemId}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`" label=""
          v-model="data.BatchNo" :rules="{ required: false }" :requiredIcon="false" :disabled="data.DCType == 3 ||
            data.DCType == 4 ||
            (data.DCType == 1 &&
              data.StockoutId != 0 &&
              data.StockOutDetailId != 0)
            ? true
            : false
            " />
      </div>
    </template>
    <template v-slot:ManufactureDate="{ data }">
      <div class="label-d-none tablefield mb-0" v-if="data.ManufactureDtRequired == true">
        <div v-if="
          requestForm.DocType == '7' ||
          requestForm.DocType == '19' ||
          requestForm.DocType != '19'
        ">
          <Datepicker dateformat="dd-mm-yy" v-model="data.ManufactureDt" :maxDate="maxDate" :disabled="data.DCType == 3 ||
            data.DCType == 4 ||
            (data.DCType == 1 &&
              data.StockoutId != 0 &&
              data.StockOutDetailId != 0)
            ? true
            : false
            " @date-select="handleDateSelect(data, 'ManufactureDt')" @change="handleDateSelect(data, 'ManufactureDt')"
            @click="handleDateSelect(data, 'ManufactureDt')" />
        </div>
        <p v-else></p>
      </div>
    </template>
    <template v-slot:ExpiryDate="{ data }">
      <div class="label-d-none tablefield mb-0" v-if="data.ExpiryDtRequired == true">
        <div v-if="requestForm.DocType == '7' || requestForm.DocType == '19'">
          <p v-if="data.DCType == 3">{{ data.ExpiryDate1 }}</p>
          <Datepicker v-else dateformat="dd-mm-yy" v-model="data.ExpiryDate1" :minDate="minExpiryDate" :disabled="data.DCType == 3 ||
            data.DCType == 4 ||
            (data.DCType == 1 &&
              data.StockoutId != 0 &&
              data.StockOutDetailId != 0)
            ? true
            : false
            " @date-select="handleDateSelect(data, 'ExpiryDate1')" @change="handleDateSelect(data, 'ExpiryDate1')"
            @click="handleDateSelect(data, 'ExpiryDate1')" />
        </div>
        <p v-else></p>
      </div>
    </template>

    <template v-slot:MRPSlot="{ data }">
      <div class="label-d-none tablefield mb-0">
        <TextField type="text" placeholder="" clearable
          :name="`'MRP'${data.ItemId}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.MRP}`"
          :id="`'MRP'${data.ItemId}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.MRP}`"
          label="" v-model="data.MRP"
          :rules="{ decimal: false, nonzeroable: ($route.query.IsZeroBill == 'true' || paramnames == 'DC') ? false : true }"
          :disabled="data.IsConsigneeItem == 1 ? true : false" />
      </div>
    </template>
    <template v-slot:FreeQty="{ data }">
      <div class="label-d-none tablefield mb-0">
        <TextField type="text" placeholder="" clearable
          :name="`'FreeQty'${data.ItemId}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.FreeQty}`"
          :id="`'FreeQty'${data.ItemId}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.FreeQty}`"
          label="" v-model="data.FreeQty" :rules="{ numeric: true }" :disabled="data.IsConsigneeItem == 1 ||
            data.DCType == 1 ||
            data.DCType == 3 ||
            data.DCType == 4
            ? true
            : false
            " />
      </div>
    </template>

    <template v-slot:SupplierBarCode="{ data }">
      <div class="label-d-none tablefield mb-0">
        <TextField type="text" placeholder="" clearable name="" id="$t('userManagement.branch.branchCode')" label=""
          v-model="data.SupplierBarCode" :rules="{ required: false }" :requiredIcon="false" :disabled="data.DCType == 3 ||
            data.DCType == 4 ||
            (data.DCType == 1 &&
              data.StockoutId != 0 &&
              data.StockOutDetailId != 0)
            ? true
            : false
            " />
      </div>
    </template>
    <!-- </NormalTable> -->
  </Tableview>

  <Toast />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  reactive,
  onMounted,
  watch,
  computed,
} from "vue";
import AddButton from "../../../../components/GeneralButtons/AddButton.vue";
import Tableview from "../../../../components/FormComponents/Table.vue";
import CustomDropdown from "../../../../components/FormComponents/Dropdown.vue";
import { FilterMatchMode } from "primevue/api";
import { object } from "yup";
import NormalTable from "../../../../components/FormComponents/NormalTable.vue";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import AutoComplete from "../../../../components/FormComponents/AutoComplete.vue";
import Datepicker from "../../../../components/FormComponents/DatePicker.vue";
import { useToast } from "primevue/usetoast";
import { useI18n } from "vue-i18n";
import ExportImport from "../../../../components/FormComponents/ExcelFileImport.vue";
import Footer from "../../../../components/FormComponents/Footer.vue";
import InputSwitch from "primevue/inputswitch";
import moment from "moment";

export default defineComponent({
  props: {
    // items: {
    //   type: Array,
    //   default: [],
    // },
    propsitems: {
      type: Array,
      default: [],
    },
    selectedList: {
      type: Array,
      default: [],
    },
    receivedtabflag: {
      type: Boolean,
      default: false,
    },
    itemcatfilteroptions: {
      type: Array,
      default: [],
    },
    requestForm: {
      type: Object,
      default: {},
    },
    receivedList: {
      type: Array,
      default: [],
    },
    DCNoDropdownLength: {
      type: Number,
      default: 0,
    },
    paramnames: {
      type: String,
      default: "",
    },
    DCType: {
      type: Number,
      default: 0,
    },
  },

  components: {
    Tableview,
    AddButton,
    CustomDropdown,
    NormalTable,
    TextField,
    Datepicker,
    ExportImport,
    AutoComplete,
    Footer,
  },
  setup(props, { emit }) {
    const items: any = ref([]);
    const Duplicateitems: any = ref([]);
    const itemcatfilter = ref();
    // const itemcatfilteroptions: any = ref([]);
    const selectedItem: any = ref([]);
    const toast = useToast();
    const { t } = useI18n();
    const SingleEntry = ref({
      item: ref(),
      qty: ref(),
      batch: ref(),
      expirydate: "",
      singleentry: ref(false),
      brand: ref(),
      modelnumber: ref(),
      size: ref(),
      ItemId: ref(),
      SupplierBarCode: ref(),
    });
    let RequiredField = ref({
      BatchRequired: ref(false),
      ExpiryDtRequired: ref(false),
    });
    const itemsList = ref([]);
    watch(
      () => props.receivedtabflag,
      (newVal) => {
        SingleEntry.value.singleentry = false
      },
      { deep: true }
    );
    watch(
      () => props.propsitems,
      (newVal) => {
        items.value = newVal;
        // items.value = JSON.parse(JSON.stringify(newVal));
        Duplicateitems.value = JSON.parse(JSON.stringify(newVal));
        if (items.value && items.value.length > 0) {
          items.value.forEach((item) => {
            if (item.ExpiryDate1) {
              console.log("Formatting ExpiryDate1 on load:", item.ExpiryDate1);
              if (
                typeof item.ExpiryDate1 === "object" &&
                item.ExpiryDate1 instanceof Date
              ) {
                item.ExpiryDate1 = `${item.ExpiryDate1.getDate()
                  .toString()
                  .padStart(2, "0")}-${(item.ExpiryDate1.getMonth() + 1)
                    .toString()
                    .padStart(2, "0")}-${item.ExpiryDate1.getFullYear()}`;
              }
            }
            if (item.ManufactureDt) {
              console.log(
                "Formatting ManufactureDt on load:",
                item.ManufactureDt
              );
              if (
                typeof item.ManufactureDt === "object" &&
                item.ManufactureDt instanceof Date
              ) {
                item.ManufactureDt = `${item.ManufactureDt.getDate()
                  .toString()
                  .padStart(2, "0")}-${(item.ManufactureDt.getMonth() + 1)
                    .toString()
                    .padStart(2, "0")}-${item.ManufactureDt.getFullYear()}`;
              }
            }
          });
        }
        itemsList.value = items.value.map((items) => {
          items.label = items.Itemname1;
          items.value = items.ItemId;
          return items;
        });
      },
      { deep: true }
    );
    watch(
      () => props.selectedList,
      (newVal) => {
        selectedItem.value = newVal;
      }
    );

    const headers = computed(() => [
      {
        header: t("storetabdetails.grncreationrallitemtable.Code"),
        field: "ItemProductId",
        class: "smallwidth normalcolumnfreezeleft2",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.Name"),
        field: "Itemname1",
        class: "smallwidth normalcolumnfreezeleft3",

        // slot: "Itemname1",
        // sortable: false,
        // fieldDisplay: "false",
      },
      {
        header: t(
          "storetabdetails.grncreationrallitemtable.Brand/ModelNumber/Size"
        ),
        field: "BrandName",
        fieldDisplay: "false",
        slot: "Brandmodelsize",
        class: "smallwidth normalcolumnfreezeleft4",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.Qty"),
        field: "Qty",
        slot: "Qty",
        sortable: false,
        fieldDisplay: "false",
        class: "smallwidth",
      },

      {
        header: t("storetabdetails.grncreationrallitemtable.POQty"),
        field: "ChkPOQty",
        bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.grncreationtable.dcqty"),
        field: "DCQuantity",
        class:
          props.paramnames == "GRN With PO" && props.DCNoDropdownLength != 0
            ? "smallwidth"
            : "d-none",
        bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.FreeQty"),
        field: "FreeQty",
        slot: "FreeQty",
        sortable: false,
        fieldDisplay: "false",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.BatchNo"),
        field: "BatchNo",
        slot: "BatchNo",
        sortable: false,
        fieldDisplay: "false",
        class: "smallwidth",
      },

      {
        header: t("storetabdetails.grncreationrallitemtable.ExpiryDate"),
        field: "",
        slot: "ExpiryDate",
        sortable: false,
        fieldDisplay: "false",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.MRP"),
        field: "MRP",
        slot: "MRPSlot",
        sortable: false,
        fieldDisplay: "false",
        // class: props.paramnames == "DC" ? "d-none" : "smallwidth",
        class: "smallwidth",

      },
      {
        header: t("storetabdetails.grncreationrallitemtable.HSN"),
        field: "HSNCode",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.PurchasingUnit"),
        field: "OrderingName",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.UOM"),
        field: "DispensingName",
      },

      {
        header: t("storetabdetails.grncreationrallitemtable.UnitRate"),
        field: "UnitRate",
        bodyclass: "right_td",
        // class: props.paramnames == "DC" ? "d-none" : "smallwidth",
        class: "smallwidth",

      },

      {
        header: t("storetabdetails.grncreationrallitemtable.Rate"),
        field: "Rate",
        bodyclass: "right_td",
        // class: props.paramnames == "DC" ? "d-none" : "smallwidth",
        class: "smallwidth",

      },
      {
        header: t("storetabdetails.grncreationrallitemtable.Discount%"),
        field: "Discount",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.Discount"),
        field: "Discountamount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.Tax%"),
        field: "PurchasePercentage",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.Tax"),
        field: "Purchasetaxamount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.SGST%"),
        field: "SGSTTax",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.SGST"),
        field: "SGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.CGST%"),
        field: "CGSTTax",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.CGST"),
        field: "CGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.IGST%"),
        field: "IGSTTax",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.IGST"),
        field: "IGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.ServiceCharges"),
        field: "servicecharges",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.OtherCharges"),
        field: "othercharges",
        bodyclass: "right_td",
        // class: props.paramnames == "DC" ? "d-none" : "smallwidth",
        class: "smallwidth",

      },
      {
        header: t("storetabdetails.grncreationrallitemtable.BarCode"),
        field: "BarCode",
        fieldDisplay: "false",
        slot: "BarCode",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.ManufactureDate"),
        field: "",
        slot: "ManufactureDate",
        sortable: false,
        fieldDisplay: "false",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.grncreationrallitemtable.Total"),
        field: "Totalvalue",
        bodyclass: "right_td",
        class: "smallwidth",
      },

      // {
      //   header: "Bin Location",
      //   field: "BinLocation",
      // },
      {
        header: t("storetabdetails.grncreationrallitemtable.SupplierBarCode"),
        field: "SupplierBarCode",
        slot: "SupplierBarCode",
        sortable: false,
        fieldDisplay: "false",
        class: "smallwidth",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "last-column-position",
        fieldDisplay: "false",
      },
    ]);

    const globalFilterFields = ref(headers.value.map((col) => col.field));

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      ItemProductId: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      Itemname1: { value: null, matchMode: FilterMatchMode.IN, options: items },
      DispensingName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      Qty: { value: null, matchMode: FilterMatchMode.IN, options: items },
      HSNManulCode: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      OrderingName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      BatchNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      RequestedQty: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      FreeQty: { value: null, matchMode: FilterMatchMode.IN, options: items },
      UnitRate: { value: null, matchMode: FilterMatchMode.IN, options: items },
      Rate: { value: null, matchMode: FilterMatchMode.IN, options: items },
      servicecharges: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      othercharges: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      Purchasetaxamount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      PurchasePercentage: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      SGSTTax: { value: null, matchMode: FilterMatchMode.IN, options: items },
      CGSTTax: { value: null, matchMode: FilterMatchMode.IN, options: items },
      CGSTTaxAmount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      IGSTTax: { value: null, matchMode: FilterMatchMode.IN, options: items },
      IGSTTaxAmount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      Discount: { value: null, matchMode: FilterMatchMode.IN, options: items },
      Discountamount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      Totalvalue: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      MRP: { value: null, matchMode: FilterMatchMode.IN, options: items },
      BrandName: { value: null, matchMode: FilterMatchMode.IN, options: items },
      BinLocation: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    function AllItemQtyOnChange(data) {
      debugger;

      if (data.ItemQuantity === "") {
        return;
      }

      if (isNaN(data.ItemQuantity) || Number(data.ItemQuantity) <= 0) {
        toast.add({
          severity: "warn",
          summary: "Invalid Quantity",
          detail: "Quantity must be a positive number greater than zero.",
          life: 3000,
        });
        data.ItemQuantity = "1";
        SingleEntry.value.qty = "1";
        return;
      }

      if (
        Number(data.ItemQuantity) >
        (data.DCType == 0 ? Number(data.ChkPOQty) : Number(data.DCQuantity))
      ) {
        toast.add({
          severity: "warn",
          summary: "Quantity Exceeds Limit",
          detail:
            "The quantity you entered exceeds the requested quantity. It has been adjusted to match the requested quantity.",
          life: 3000,
        });
        data.ItemQuantity = data.DCType == 0 ? data.ChkPOQty : data.DCQuantity;
        data.Rate = Number(data.ItemQuantity * data.UnitRate).toFixed(2);

        let BeforeDiscountRate = data.Rate;

        const discountAmount = ((data.Discount || 0.0) / 100) * data.Rate;
        data.Discountamount = discountAmount.toFixed(2);

        data.Rate = (data.Rate - data.Discountamount || 0.0).toFixed(2);

        data.Purchasetaxamount = (
          data.Rate *
          (data.PurchasePercentage / 100)
        ).toFixed(2);

        if (data.SGSTTax && data.CGSTTax) {
          data.SGSTTaxAmount = Number(
            Number(data.Purchasetaxamount) / 2
          ).toFixed(2);

          data.CGSTTaxAmount = Number(
            Number(data.Purchasetaxamount) / 2
          ).toFixed(2);
        }

        if (data.IGSTTax) {
          data.IGSTTaxAmount = Number(
            (data.PurchasePercentage * data.Rate) / 100
          ).toFixed(2);
        }

        data.Rate = BeforeDiscountRate;

        data.Totalvalue = Number(
          Number(data.Rate) -
          Number(data.Discountamount || 0.0) +
          Number(data.Purchasetaxamount) +
          Number(data.servicecharges || 0.0) +
          Number(data.othercharges || 0.0)
        ).toFixed(2);
        SingleEntry.value.qty = items.value[ItemIndex].ChkPOQty;

        return false;
      } else if (
        // Number(data.ItemQuantity) >
        // (data.DCType == 0 ? Number(data.ChkPOQty) : Number(data.DCQuantity))
        props.paramnames == "DC" &&
        props.DCType == 2 &&
        Number(data.ItemQuantity) > Number(data.IssuedQty)
      ) {
        toast.add({
          severity: "warn",
          summary: "Quantity Exceeds Limit",
          detail:
            "The quantity you entered exceeds the GRN quantity. It has been adjusted to match the GRN quantity.",
          life: 3000,
        });
        data.ItemQuantity = data.IssuedQty;

        data.Rate = Number(data.ItemQuantity * data.UnitRate).toFixed(2);

        let BeforeDiscountRate = data.Rate;

        const discountAmount = ((data.Discount || 0.0) / 100) * data.Rate;
        data.Discountamount = discountAmount.toFixed(2);

        data.Rate = (data.Rate - data.Discountamount || 0.0).toFixed(2);

        data.Purchasetaxamount = (
          data.Rate *
          (data.PurchasePercentage / 100)
        ).toFixed(2);

        if (data.SGSTTax && data.CGSTTax) {
          data.SGSTTaxAmount = Number(
            Number(data.Purchasetaxamount) / 2
          ).toFixed(2);

          data.CGSTTaxAmount = Number(
            Number(data.Purchasetaxamount) / 2
          ).toFixed(2);
        }

        if (data.IGSTTax) {
          data.IGSTTaxAmount = Number(
            (data.PurchasePercentage * data.Rate) / 100
          ).toFixed(2);
        }

        data.Rate = BeforeDiscountRate;
        data.Totalvalue = Number(
          Number(data.Rate) -
          Number(data.Discountamount || 0.0) +
          Number(data.Purchasetaxamount) +
          Number(data.servicecharges || 0.0) +
          Number(data.othercharges || 0.0)
        ).toFixed(2);
        SingleEntry.value.qty = items.value[ItemIndex].ChkPOQty;

        return false;
      } else {
        data.Rate = Number(data.ItemQuantity * data.UnitRate).toFixed(2);

        let BeforeDiscountRate = data.Rate;

        const discountAmount = ((data.Discount || 0.0) / 100) * data.Rate;
        data.Discountamount = discountAmount.toFixed(2);

        data.Rate = (data.Rate - data.Discountamount || 0.0).toFixed(2);

        data.Purchasetaxamount = (
          data.Rate *
          (data.PurchasePercentage / 100)
        ).toFixed(2);

        if (data.SGSTTax && data.CGSTTax) {
          data.SGSTTaxAmount = Number(
            Number(data.Purchasetaxamount) / 2
          ).toFixed(2);

          data.CGSTTaxAmount = Number(
            Number(data.Purchasetaxamount) / 2
          ).toFixed(2);
        }

        if (data.IGSTTax) {
          data.IGSTTaxAmount = Number(
            (data.PurchasePercentage * data.Rate) / 100
          ).toFixed(2);
        }

        data.Rate = BeforeDiscountRate;

        data.Totalvalue = Number(
          Number(data.Rate) -
          Number(data.Discountamount || 0.0) +
          Number(data.Purchasetaxamount) +
          Number(data.servicecharges || 0.0) +
          Number(data.othercharges || 0.0)
        ).toFixed(2);
        emit("GRNCalculation", selectedItem.value);
      }
    }

    const maxDate = ref(new Date());
    const Itemschanges = (value) => {
      debugger;
      if (value != "") {
        items.value = [];
        items.value = value;
      }
    };
    function ExcelDataImport(ExcelData) {
      debugger;
      emit("ExcelData", ExcelData);
    }

    const filterCondition = (event) => {
      emit("FilterPOItems", itemcatfilter.value);
    };

    // Create a date 5 days from today for minimum expiry date
    const minExpiryDate = computed(() => {
      const date = new Date();
      date.setDate(date.getDate() + 30);
      return date;
    });

    // Function to handle date selection
    const handleDateSelect = (data, fieldName) => {
      debugger; // Add debugger statement to pause execution for debugging
      console.log(`Date selected for ${fieldName}:`, data[fieldName]);
      console.log("Data object:", data);

      // If the field is empty or undefined, set it to today's date
      if (!data[fieldName] || data[fieldName] === "") {
        console.log(`${fieldName} is empty, setting to today's date`);
        const today = new Date();
        data[fieldName] = today;
      }

      // Format the date immediately after selection
      let formattedDate = "";

      try {
        if (typeof data[fieldName] === "object") {
          if (data[fieldName] instanceof Date) {
            // If it's a Date object, format it
            const dateObj = data[fieldName];
            formattedDate = `${dateObj
              .getDate()
              .toString()
              .padStart(2, "0")}-${(dateObj.getMonth() + 1)
                .toString()
                .padStart(2, "0")}-${dateObj.getFullYear()}`;
          } else if (data[fieldName] && "__v_isRef" in data[fieldName]) {
            // If it's a Vue ref, try to get the actual date value
            console.log("It is a Vue ref in handleDateSelect");
            if (data[fieldName]._value instanceof Date) {
              const dateObj = data[fieldName]._value;
              formattedDate = `${dateObj
                .getDate()
                .toString()
                .padStart(2, "0")}-${(dateObj.getMonth() + 1)
                  .toString()
                  .padStart(2, "0")}-${dateObj.getFullYear()}`;
            } else if (typeof data[fieldName]._value === "string") {
              formattedDate = data[fieldName]._value;
            } else {
              // Use today's date as a fallback
              const today = new Date();
              formattedDate = `${today
                .getDate()
                .toString()
                .padStart(2, "0")}-${(today.getMonth() + 1)
                  .toString()
                  .padStart(2, "0")}-${today.getFullYear()}`;
            }
          } else if (
            data[fieldName] &&
            typeof data[fieldName].getMonth === "function" &&
            typeof data[fieldName].getDate === "function" &&
            typeof data[fieldName].getFullYear === "function"
          ) {
            // If it has date methods but isn't a Date instance
            formattedDate = `${data[fieldName]
              .getDate()
              .toString()
              .padStart(2, "0")}-${(data[fieldName].getMonth() + 1)
                .toString()
                .padStart(2, "0")}-${data[fieldName].getFullYear()}`;
          }
        } else if (typeof data[fieldName] === "string") {
          // If it's already a string, check if it's in the correct format
          if (/^\d{2}-\d{2}-\d{4}$/.test(data[fieldName])) {
            formattedDate = data[fieldName]; // Already in DD-MM-YYYY format
          } else {
            // Try to parse the string as a date
            const parsedDate = new Date(data[fieldName]);
            if (!isNaN(parsedDate.getTime())) {
              formattedDate = `${parsedDate
                .getDate()
                .toString()
                .padStart(2, "0")}-${(parsedDate.getMonth() + 1)
                  .toString()
                  .padStart(2, "0")}-${parsedDate.getFullYear()}`;
            } else {
              formattedDate = data[fieldName];
            }
          }
        }

        // If we couldn't format the date, use today's date
        if (!formattedDate) {
          const today = new Date();
          formattedDate = `${today.getDate().toString().padStart(2, "0")}-${(
            today.getMonth() + 1
          )
            .toString()
            .padStart(2, "0")}-${today.getFullYear()}`;
        }

        console.log(`Formatted ${fieldName}:`, formattedDate);
        data[fieldName] = formattedDate;
      } catch (e) {
        console.error("Error in handleDateSelect:", e);
        // Use today's date as a fallback
        const today = new Date();
        formattedDate = `${today.getDate().toString().padStart(2, "0")}-${(
          today.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${today.getFullYear()}`;
        data[fieldName] = formattedDate;
      }
    };
    let ItemIndex = '';
    const selectItem = async (event) => {
      debugger;
      await LoadItem();
      SingleEntry.value.brand = event.value.Brand;
      SingleEntry.value.modelnumber = event.value.ModelNumber;
      SingleEntry.value.size = event.value.Size;
      SingleEntry.value.ItemId = event.value.ItemId;
      RequiredField.value.BatchRequired = event.value.BatchRequired;
      RequiredField.value.ExpiryDtRequired = event.value.ExpiryDtRequired;
      ItemIndex = items.value.findIndex(
        (item) =>
          item.ItemId === SingleEntry.value.ItemId &&
          item.Brand === SingleEntry.value.brand &&
          item.ModelNumber === SingleEntry.value.modelnumber &&
          item.Size === SingleEntry.value.size
      );
    };
    const SingleEntrySubmit = () => {
      if (
        isNaN(SingleEntry.value.ItemId) ||
        Number(SingleEntry.value.ItemId) == 0
      ) {
        toast.add({
          severity: "warn",
          summary: "Invalid Input",
          detail: "Please choose  a Item.",
          life: 3000,
        });
        return;
      }
      if (isNaN(SingleEntry.value.qty) || !SingleEntry.value.qty) {
        toast.add({
          severity: "warn",
          summary: "Invalid Input",
          detail: "Please enter a valid number.",
          life: 3000,
        });
        return;
      }
      debugger;
      let selectedIndex = selectedItem.value.findIndex(
        (item) =>
          item.ItemId === SingleEntry.value.ItemId &&
          item.Brand === SingleEntry.value.brand &&
          item.ModelNumber === SingleEntry.value.modelnumber &&
          item.Size === SingleEntry.value.size
      );
      if (selectedIndex != -1) {
        selectedItem.value[selectedIndex].ItemQuantity = SingleEntry.value.qty;
        selectedItem.value[selectedIndex].BatchNo = SingleEntry.value.batch;
        selectedItem.value[selectedIndex].ExpiryDate1 = moment(
          SingleEntry.value.expirydate,
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        ).format("DD-MM-YYYY");
        selectedItem.value[selectedIndex].SupplierBarCode =
          SingleEntry.value.SupplierBarCode;

        ClearField();
      } else {
        items.value[ItemIndex].ItemQuantity = SingleEntry.value.qty;
        items.value[ItemIndex].BatchNo = SingleEntry.value.batch;
        items.value[ItemIndex].ExpiryDate1 = SingleEntry.value.expirydate;
        items.value[ItemIndex].SupplierBarCode =
          SingleEntry.value.SupplierBarCode;
        selectedItem.value = [];
        selectedItem.value.push(items.value[ItemIndex]);
        ClearField();
      }
      emit("AddSelectItems", selectedItem.value);
    };
    const ClearField = () => {
      debugger;
      SingleEntry.value.item = "";
      SingleEntry.value.qty = null;
      SingleEntry.value.batch = null;
      SingleEntry.value.expirydate = "";
      SingleEntry.value.brand = null;
      SingleEntry.value.modelnumber = null;
      SingleEntry.value.size = null;
      SingleEntry.value.ItemId = null;
      SingleEntry.value.SupplierBarCode = null;
      LoadItem();
    };
    const LoadItem = () => {
      // debugger;
      // items.value = Duplicateitems.value.filter((item: any) =>
      //   item.Itemname1.toLowerCase().includes(
      //     SingleEntry.value.item.toLowerCase()
      //   )
      // );
    };
    const ItemQuantityCheck = () => {
      debugger;
      if (ItemIndex != '') {
        items.value[ItemIndex].ItemQuantity =
          SingleEntry.value.qty != ""
            ? SingleEntry.value.qty
            : items.value[ItemIndex].ChkPOQty;
        AllItemQtyOnChange(items.value[ItemIndex]);
      }
    };
    const InputSwitch = () => {
      // ClearField()
    };


    function SelectItems(value) {
      debugger;
      selectedItem.value = value;
    }

    return {
      filterCondition,
      ExcelDataImport,
      Itemschanges,
      maxDate,
      minExpiryDate,
      globalFilterFields,
      filters,
      headers,
      items,
      itemcatfilter,
      selectedItem,
      AllItemQtyOnChange,
      handleDateSelect,
      SingleEntry,
      SingleEntrySubmit,
      itemsList,
      selectItem,
      RequiredField,
      InputSwitch,
      ItemIndex,
      LoadItem,
      ItemQuantityCheck,
      SelectItems
    };
  },
});
</script>
<style>
.singleentryposition {
  position: absolute;
  top: 11%;
  left: 2%;
  z-index: 10;
  display: flex;
  gap: 10px;
  align-items: center;
}

.singleswitch {
  flex: none;
}
</style>
